export default {
  changeInfo: 'Change info',
  disable: 'Disable',
  showPayment: 'View payment',
  sendMessage: 'Send message',
  next: 'Next',
  copy: 'Copy',
}